import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import { setActiveFooter } from "../../../actions/foooterTabs.action";
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useEffect, useState } from "react";
import { updateUUID } from "../../../services/saveResponse";
export default function FooterControls() {
  const [userMeta, setUserMeta] = useState<{ name: string, email: string, isBabyPlan?: boolean; isRootAgency?: boolean; phone: { prefix: string; number: string; } }>({ name: '', email: '', phone: { prefix: '', number: ''} });
  const [postMessageRecieved, setPostMessageRecieved] = useState(false);
  const [ enableWhatsapp, setEnableWhatsapp ] = useState(false);
  const dispatch = useDispatch();
  const configuration = useSelector((state: any) => state?.configuration);
  const environment = useSelector((state: any) => state?.environment);
  
  const activeTab: 'Chat' | 'Knowledge Base' | 'Tickets' = useSelector((state: any) => state && state.footerTab);

  const setFooter = (payload: 'Chat' | 'Knowledge Base' | 'Tickets') => {
    dispatch(setActiveFooter(payload))
  }

  /**
   * Author: Satyam Sharma
   * Date: 25-04-2025
   * Summary: Refer to changelog [1.15.4]
   */
  useEffect(() => {
    try {
      if (sessionStorage.getItem('isUnsure') === "true" || environment.isAiUnsure) {
        setEnableWhatsapp(true);
      }
    } catch (error) {
      console.log(error);
    }
  }, [environment.isAiUnsure]);

  const isEnabled = (type: 'knowledgeBase' | 'tickets' | 'whatsapp'): boolean => {
    switch (type) {
      case "knowledgeBase":
        return !!configuration && configuration.chatMenu && configuration.chatMenu.knowledgeBase?.enabled;
      case "tickets":
        return !!configuration && configuration.chatMenu && configuration.chatMenu.ticketing?.enabled;
      case 'whatsapp':
        return userMeta?.isRootAgency || false;
      default:
        return false;
    }
  }

  const openWhatsAppWindow = () => {
    // Refer to changelog [1.15.4]
    if( !enableWhatsapp) {
      return;
    }

    const whatsAppNumber = !userMeta.isBabyPlan ? '919740374298' : '916283368463';

    const body = `Hi Team,
I want to build WhatsApp Bot, Please help us build the same. Here are my details

Registered Email: ${userMeta?.email || ''}
Registered Phone: ${userMeta?.phone?.number || 'N/A'}

Thanks`;
    window.open(`https://wa.me/${whatsAppNumber}/?text=${encodeURIComponent(body)}`, '_blank\'');
  }

  useEffect(() => {
    const messageHandler = (event: any) => {
      if (event.data.origin === 'BotPenguin') {
        if (event.data.action === 'getRequestedUserMeta' && !userMeta.email) {
          setUserMeta(event.data.payload);
          setPostMessageRecieved(true);
          updateUUID({
            email: event.data.payload.email,
            lead: true
            }).catch();
        }
      }
    }
    window.addEventListener('message', messageHandler);
    let timeout: any;
    if (!userMeta.email && !postMessageRecieved) {

      window.parent.postMessage({
        origin: 'BotPenguin',
        action: 'requestingUserMeta'
      }, '*');
    }

    // Only for dev purpose
    // if (process.env.NODE_ENV === 'development') {
    //   window.postMessage({
    //     origin: 'BotPenguin',
    //     action: 'getRequestedUserMeta',
    //     payload: { name: 'BP TEST', email: 'divyansh@relinns.com', isBabyPlan: true, isRootAgency: true, phone: { prefix: '91', number: '1110001110' } }
    //   }, '*');
    // }

    return () => {
      window.removeEventListener('message', messageHandler);

      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [userMeta.email, postMessageRecieved]);
  return (
    <>
      <div id='ele-26' className="flex flex-row items-center justify-evenly h-full bg-primaryBgColor py-1">
        <div id='ele-27' className="text-center cursor-pointer" onClick={() => setFooter('Chat')}>
          <span id='ele-28' className={`px-5 py-2 flex w-fit m-auto ${activeTab === 'Chat' && 'bg-footerSelectedBG rounded-3xl'}`}>
            <ChatBubbleIcon id='ele-29' className={`align-middle !text-2xl text-footer m-auto ${activeTab === 'Chat' && '!text-footerSelected '}`} />
          </span>
          <div id='ele-30' className="text-sm mt-2 ">Chat</div>
        </div>
        {
          isEnabled("knowledgeBase") &&
          <div id='ele-31' className="text-center cursor-pointer" onClick={() => setFooter('Knowledge Base')}>
            <span id='ele-32' className={`px-5 py-2 flex w-fit m-auto ${activeTab === 'Knowledge Base' && 'bg-footerSelectedBG rounded-3xl'}`}>
              <MenuBookIcon id='ele-33' className={`align-middle !text-2xl text-footer m-auto ${activeTab === 'Knowledge Base' && '!text-footerSelected '}`} />
            </span>
            <div id='ele-34' className="text-sm mt-2">Knowledge Base</div>
          </div>
        }
        {
          isEnabled("tickets") &&
          <div id='ele-35' className="text-center cursor-pointer" onClick={() => setFooter('Tickets')}>
            <span id='ele-36' className={`px-5 py-2 flex ${activeTab === 'Tickets' && 'bg-footerSelectedBG rounded-3xl'}`}>
              <LocalActivityIcon id='ele-37' className={`align-middle !text-2xl text-footer m-auto ${activeTab === 'Tickets' && '!text-footerSelected '}`} />
            </span>
            <div id='ele-38' className="text-sm mt-2">Tickets</div>
          </div>
        }
        {
          isEnabled("whatsapp") &&
          <div id='ele-413' className={"text-center" + (enableWhatsapp ? " cursor-pointer" : '') } onClick={openWhatsAppWindow}>
            <span id='ele-414' className={`px-5 py-2 flex`}>
              <WhatsAppIcon 
              color={enableWhatsapp ? "success" : "disabled"} id='ele-415' className={`align-middle !text-2xl text-footer m-auto`} />
            </span>
            <div id='ele-416' className="text-sm mt-2">WhatsApp</div>
          </div>
        }
      </div>
    </>
  );
}

